import { render, staticRenderFns } from "./EmailAddIcon.vue?vue&type=template&id=27a99dd0&scoped=true"
import script from "./EmailAddIcon.vue?vue&type=script&lang=js"
export * from "./EmailAddIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a99dd0",
  null
  
)

export default component.exports